import { InlineSpinner, MessageDialog } from "@graffer-inc/console-design-kit";
import { reportAsyncError } from "@graffer-inc/smart-apply";
import React, { useEffect } from "react";

export type AuthAuditLogsDownloadDialogProps = {
  onClose: () => void;
  exportAndDownloadAuthAuditLogs: (
    onExportSuccess: () => void,
    onExportError: (e: Error) => void,
  ) => Promise<void>;
};

export const AuthAuditLogsDownloadDialog: React.FC<
  AuthAuditLogsDownloadDialogProps
> = ({ onClose, exportAndDownloadAuthAuditLogs }) => {
  const [isDownloading, setIsDownloading] = React.useState(false);

  const onExportSuccess = () => {
    setIsDownloading(false);
    onClose();
  };

  const onExportError = (e: Error) => {
    setIsDownloading(false);
    reportAsyncError(e);
    onClose();
  };

  useEffect(() => {
    setIsDownloading(true);
    exportAndDownloadAuthAuditLogs(onExportSuccess, onExportError);
  }, []);

  return (
    <MessageDialog
      title="認証ログのダウンロードを開始しました"
      onCancel={onClose}
      cancelText="閉じる"
      contents={
        <div className="modal-card-body">
          <p>
            認証ログのダウンロードを開始しました。このウィンドウを閉じないでください。
          </p>
          <p>
            また、ダウンロードが完了するまでに数分程度かかることがあります。
          </p>
          {isDownloading && (
            <div className="m-4 is-flex is-justify-content-center">
              <InlineSpinner />
            </div>
          )}
        </div>
      }
    />
  );
};
